export type IDateFormatKey = keyof typeof DATE_FORMAT_BY_COUNTRY;

type IDateFormat = Record<IDateFormatKey, string>;

export const DATE_FORMAT_BY_COUNTRY = {
    us: 'M/d/yyyy',
    uk: 'dd/MM/yyyy',
    lt: 'yyyy-MM-dd',
    pl: 'dd.MM.yyyy',
    ko: 'yyyy.MM.dd',
    ch: 'yyyy-MM-dd',
};

export const TIME_FORMAT_BY_COUNTRY: IDateFormat = {
    us: 'h:mm a',
    uk: 'HH:mm',
    lt: 'HH:mm',
    pl: 'HH:mm',
    ko: 'HH:mm',
    ch: 'HH:mm',
};

export const TIME_FULL_FORMAT_BY_COUNTRY: IDateFormat = {
    us: 'h:mm:ss a',
    uk: 'HH:mm:ss',
    lt: 'HH:mm:ss',
    pl: 'HH:mm:ss',
    ko: 'HH:mm:ss',
    ch: 'HH:mm:ss',
};

export const DATE_TIME_FORMAT_BY_COUNTRY: IDateFormat = {
    us: `${DATE_FORMAT_BY_COUNTRY.us}, ${TIME_FULL_FORMAT_BY_COUNTRY.us}`,
    uk: `${DATE_FORMAT_BY_COUNTRY.uk}, ${TIME_FULL_FORMAT_BY_COUNTRY.uk}`,
    lt: `${DATE_FORMAT_BY_COUNTRY.lt}, ${TIME_FULL_FORMAT_BY_COUNTRY.lt}`,
    pl: `${DATE_FORMAT_BY_COUNTRY.pl}, ${TIME_FULL_FORMAT_BY_COUNTRY.pl}`,
    ko: `${DATE_FORMAT_BY_COUNTRY.ko}, ${TIME_FULL_FORMAT_BY_COUNTRY.ko}`,
    ch: `${DATE_FORMAT_BY_COUNTRY.ch}, ${TIME_FULL_FORMAT_BY_COUNTRY.ch}`,
};

export const DEFAULT_DATE_FORMAT_KEY: IDateFormatKey = 'lt';

export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';

export const DEFAULT_TIME_FULL_FORMAT = 'HH:mm:ss';

export const DEFAULT_TIMER_FORMAT = 'hMS';
